import React from 'react';


function AffiliatePageTop(props) {
  return (
    <div className="affiliate container top-section">
      <div className="flex flex-col justify-center items-start content pull-right">
        <h1 className="title-large">
          MAKE MONEY<br />PROMOTING OUR<br />EXCLUSIVE CONTENT
        </h1>
        <h3>Setup your account and start earning today.</h3>
        <a
          className="btn"
          href={props.affiliateURL}
          rel="noreferrer" target="_blank"
        >SIGN UP
        </a>
      </div>
    </div>
  );
}

export default AffiliatePageTop;
